/**
 * Liferay API utilities.
 *
 * Uses BFF only to fetch an auth token (/o/tokenService/get-token).
 * All headless API calls are made directly from the client with the Bearer token.
 */

class OAuth2 {
  constructor() {
    this._token = null;
  }

  /**
   * In production / Liferay: uses the portal URL.
   * In dev: returns '' so requests go to localhost and the Vite proxy
   * forwards /o/* to https://sammaancapital.infoaxon.com.
   */
  getPortalURL() {
    if (typeof window !== 'undefined' && window.Liferay?.ThemeDisplay) {
      return window.Liferay.ThemeDisplay.getPortalURL();
    }
    if (import.meta.env.DEV) {
      return '';
    }
    return window.location.origin;
  }

  /**
   * Fetch auth token from the BFF token service (server-side secured).
   * Token is cached for the lifetime of the page.
   */
  async getAccessToken() {
    if (this._token) return this._token;
    try {
      const response = await fetch(this.getPortalURL() + '/o/tokenService/get-token', {
        method: 'GET',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error(`Token request failed: ${response.status}`);
      const result = await response.json();
      this._token = result?.data?.accessToken || null;
      return this._token;
    } catch (error) {
      console.error('Error fetching access token:', error);
      return null;
    }
  }

  /**
   * Get headers with Bearer token for direct headless API calls.
   */
  async getHeaders() {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
    const token = await this.getAccessToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
  }
}

const oauth2Instance = new OAuth2();

export default OAuth2;
export { oauth2Instance };
